export default "__VITE_ASSET__B8FMyiMp__"